module.exports = __webpack_public_path__ + "img/bldg1516-h-474x356.14b09fd4.jpg";